export default function Terms() {
  return (
    <div className="pt-32 pb-24 max-w-3xl mx-auto px-6 lg:px-10">
      <div className="text-xs uppercase tracking-[0.24em] text-amber-600 mb-4">Legal</div>
      <h1 className="font-display text-5xl text-slate-950 leading-none">Terms & Conditions</h1>
      <div className="mt-8 space-y-4 text-slate-700 leading-relaxed">
        <p>All bookings and services provided are subject to the terms outlined here. This website is for information and inquiry purposes only — no online booking, checkout, or payment is processed via this site.</p>
        <p>Cancellations 30+ days prior to travel receive a 90% refund of amounts paid; 15–29 days, 50%; less than 15 days, non-refundable. Force majeure events are handled compassionately with alternate dates or credits.</p>
        <p>All prices are indicative in Indian Rupees and subject to seasonality, availability, and taxes at time of quotation.</p>
      </div>
    </div>
  );
}
